import React, { useRef, useState } from "react";

// JS port of portal's TagInput (src/shared/components/TagInput.tsx), restyled
// for the hero's dark modal. Enter commits the current input as a chip, Backspace
// on empty input removes the last chip, duplicates are deduped. value is an
// array of strings; onChange emits the new array.
const HeroTagInput = ({ value = [], onChange, placeholder = "Type a tag and press Enter" }) => {
    const [inputValue, setInputValue] = useState("");
    const inputRef = useRef(null);

    const commitTag = (text) => {
        const trimmed = (text || "").trim();
        if (!trimmed) return;
        if (value.includes(trimmed)) return;
        onChange && onChange([...value, trimmed]);
    };

    const removeTag = (tag) => {
        onChange && onChange(value.filter((t) => t !== tag));
    };

    const handleKeyDown = (e) => {
        if (e.key === "Enter") {
            e.preventDefault();
            commitTag(inputValue);
            setInputValue("");
        } else if (e.key === "Backspace" && !inputValue && value.length > 0) {
            // Remove last chip when input is empty (mirrors portal behaviour)
            onChange && onChange(value.slice(0, -1));
        }
    };

    return (
        <div
            className="lv2-pm-tag-input"
            onClick={() => inputRef.current && inputRef.current.focus()}
            role="textbox"
        >
            {value.map((tag) => (
                <span key={tag} className="lv2-pm-tag-chip manrope f-12 w-500">
                    <span>{tag}</span>
                    <button
                        type="button"
                        className="lv2-pm-tag-chip-close"
                        aria-label={`Remove ${tag}`}
                        onClick={(e) => { e.stopPropagation(); removeTag(tag); }}
                    >
                        <svg width="8" height="8" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M1 1L9 9M9 1L1 9" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
                        </svg>
                    </button>
                </span>
            ))}
            <input
                ref={inputRef}
                type="text"
                className="lv2-pm-tag-input-field manrope f-13 w-400"
                value={inputValue}
                onChange={(e) => setInputValue(e.target.value)}
                onKeyDown={handleKeyDown}
                onBlur={() => {
                    // Commit any half-typed tag when the field loses focus, so the user
                    // doesn't lose work by clicking Add without pressing Enter first.
                    if (inputValue.trim()) {
                        commitTag(inputValue);
                        setInputValue("");
                    }
                }}
                placeholder={value.length === 0 ? placeholder : ""}
            />
        </div>
    );
};

export default HeroTagInput;
